import { Component, OnInit, ViewChild } from '@angular/core';
import { DialogService } from '../../../../common/dialog.service';
import { CourseService } from '../../../../api/Services/maintenance/course.service';
import { TabService } from '../../../../tabconfig/tab.service';
import { AuthService } from '../../../../system/auth.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CoursesQuizTitleComponent } from '../courses-quiz-title/courses-quiz-title.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { CourseQuizService } from '../../../../api/Services/maintenance/course-quiz.service';
import { CoursesQuizCreateComponent } from '../courses-quiz-create/courses-quiz-create.component';
import { Tab } from '../../../../tabconfig/tab.model';
import { CoursesQuizTitleAssignComponent } from '../courses-quiz-title-assign/courses-quiz-title-assign.component';

@Component({
  selector: 'app-courses-quiz',
  templateUrl: './courses-quiz.component.html',
  styleUrls: ['./courses-quiz.component.css']
})
export class CoursesQuizComponent implements OnInit {

  public displayedColumns: string[] = ['coquti_tx_description',  'opcion'];
  public dataSource = new MatTableDataSource<any[]>();
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild('paginatorDatasource', {read: MatPaginator, static: true}) paginator: MatPaginator;

  
  dataCourses:any[];
  constructor(
    private toastr: ToastrService,
    private dialogService: DialogService,
    private courseServices: CourseService,
    private tabService: TabService,
    private dialog: MatDialog,
    private courseQuizServices: CourseQuizService,
    private authService : AuthService
  ) { }

  ngOnInit(): void {
    this.LoadCourses();
    this.LoadQuizTitle();
  }

  addquestion()
  {
    
      const dialogConfig = new MatDialogConfig();
       
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
     //   dialogConfig.data = element.asfico_vc_file;
        dialogConfig.minWidth = '50%';
       
  
        const dialogRef = this.dialog.open(CoursesQuizTitleComponent, dialogConfig);
  
        dialogRef.afterClosed().subscribe(result => {
          this.LoadQuizTitle();
        });
      
      
  
     
  }
  LoadQuizTitle(){
    this.courseQuizServices.GetAlltQuizTitle(0).subscribe(
      data => {
       
        if (data['sucess']) {
         
          let result = data['data'];
          console.log(result);
       
          this.dataSource = new MatTableDataSource<any[]>(result);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;

        }
        else {
          this.toastr.warning(data['msg'], 'Advertencia');
        }
      }
    );
  }
  LoadCourses(){
    this.courseServices.GetAll(0,0,2).subscribe(
      data => {
        console.log(data);
        
        if(data['sucess']){
          let result = data['data'];
          console.log(result);
          this.dataCourses = result;
        }
        else{
          this.toastr.warning('hubo un problema al tratar de obtener los datos', 'Advertencia');
        }
 
      }
    );
  }

  create_quiz(element) {
    this.tabService.addTab(new Tab(CoursesQuizCreateComponent, "Encuesta", { parent: 'ListadoComponent', element: element }));
  }
  delete_quiz_title(element){
    
    this.dialogService.openConfirmDialog('¿Seguro de eliminar este registro?')
    .afterClosed().subscribe(res => {
      this.courseQuizServices.DeleteQuizTitle(element.coquti_bi_id).subscribe(
        data => {
          if (data['sucess']) {
            this.LoadQuizTitle();
            this.toastr.success(data['msg'], 'Correcto');
          }
          else {
            this.toastr.warning(data['msg'], 'Advertencia');
          }
        }
      );

    });

  }

  asign_quiz(element)
  {
    this.tabService.addTab(new Tab(CoursesQuizTitleAssignComponent, "Asignar Encuesta", { parent: 'ListadoComponent', element: element }));
  }
}
